
export const environment = {
  apiBaseUri: 'https://artsway-portal.azurewebsites.net/api/',
  apiDevUri: 'https://artsway-portal.azurewebsites.net/api/',
  production: true
};
